import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BodyText } from '@/common/components/BodyText/BodyText';
import { CardAction } from '@/common/components/CardAction/CardAction';
import { Icon } from '@/common/components/Icons/Icon';
import { Modal } from '@/common/components/Modal/Modal';
import { Translate } from '@/common/components/Translate/Translate';
import { SimulateFamilyMembersModal } from '@/common/containers/Dashboard/Insurance/InsuranceHomePage/InsurancePolicyDetail/SimulateFamilyMembersModal/SimulateFamilyMembersModal';
import { useMarket } from '@/common/hooks/useMarket';
import { IInsurancePolicy } from '@/common/integrations/menhir/employee/insurance/insurance.types';
import { getInsuranceFamilyPaymentType } from '@/common/integrations/menhir/employee/insurance/insurance.utils';
import { buildDescription } from './SimulateFamilyMembersCTA.utils';

export const SimulateFamilyMembersCTA = ({
  policy,
}: TSimulateFamilyMembersCTAProps) => {
  const { t } = useTranslation();
  const { slug } = useMarket();
  const description = buildDescription(policy, slug);
  const paymentType = getInsuranceFamilyPaymentType(policy);
  const [showSimulationModal, setShowSimulationModal] = useState(false);
  const [showSavingsModal, setShowSavingsModal] = useState(false);

  const cardTitle =
    paymentType === 'pay_none'
      ? t('dashboard.insurance_detail.add_family_member.title')
      : t('dashboard.insurance_detail.simulate_family.title');

  return (
    <>
      <CardAction
        iconBadgeColor="accentPrimary40"
        size="md"
        icon={<Icon icon="family-pants" />}
        title={cardTitle}
        description={description}
        onPress={() => {
          setShowSimulationModal(true);
        }}
        action={<Icon icon="chevron-right" />}
      />
      {showSimulationModal && (
        <SimulateFamilyMembersModal
          onClose={() => setShowSimulationModal(false)}
          policyId={policy.id}
          showSavingsModal={() => {
            setShowSavingsModal(true);
          }}
        />
      )}
      {showSavingsModal && (
        <Modal
          title={t(
            'dashboard.insurance_detail.simulate_family.savings_modal.title'
          )}
          iconBadgeColor="accentPrimary20"
          icon={<Icon icon="badge-percent" />}
          onClose={() => {
            setShowSavingsModal(false);
          }}
          name="savings-modal"
        >
          <Translate
            parent={BodyText}
            i18nKey="dashboard.insurance_detail.simulate_family.savings_modal.description"
            components={{ strong: <BodyText bold /> }}
          />
        </Modal>
      )}
    </>
  );
};

export type TSimulateFamilyMembersCTAProps = {
  policy: IInsurancePolicy;
};
